// extracted by mini-css-extract-plugin
export var calendarView = "_o2-0";